import React, { useMemo } from 'react';

/**
 * Pure CSS confetti burst. Renders 20 colored dots that scatter
 * upward + outward from a centered origin and fade out over 1.2s.
 * Caller controls mount/unmount.
 */
const COLORS = ['#0e8175', '#10b981', '#f59e0b', '#f43f5e', '#7c3aed', '#22d3ee'];

export const Confetti = ({ count = 22 }) => {
  const pieces = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      // Random angle in the upper hemisphere, mostly upward
      const angle = (Math.random() * Math.PI) - Math.PI; // -180° to 0°  (upper half)
      const distance = 80 + Math.random() * 140;
      const cx = Math.cos(angle) * distance;
      const cy = Math.sin(angle) * distance + Math.random() * 60; // bias upward
      const color = COLORS[i % COLORS.length];
      const size = 6 + Math.random() * 6;
      const delay = Math.random() * 80;
      return { cx, cy, color, size, delay, id: i };
    });
  }, [count]);

  return (
    <div className="pointer-events-none absolute inset-0 z-50 overflow-visible" data-testid="confetti-burst">
      {pieces.map((p) => (
        <span
          key={p.id}
          className="creataby-confetti-piece"
          style={{
            '--cx': `${p.cx}px`,
            '--cy': `${p.cy}px`,
            background: p.color,
            width: p.size,
            height: p.size,
            animationDelay: `${p.delay}ms`,
          }}
        />
      ))}
    </div>
  );
};

export default Confetti;
